import type { ScheduleAlert } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlert.ts";
import type { ScheduleAlertLevel } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlertLevel.ts";
import { formatMessage } from "@/shared/utils/LegacyStringTemplate.ts";

export interface ScheduleAlertOut {
  employeeId: number;
  level: string;
  template: string;
  arguments: string[];
}

export function mapToAlert(dto: ScheduleAlertOut): ScheduleAlert {
  return {
    employeeId: dto.employeeId.toString(),
    level: mapAlertLevel(dto.level),
    htmlMessage: formatMessage(
      dto.template,
      dto.arguments.map((s) => `<b>${s}</b>`),
    ),
  };
}

function mapAlertLevel(str: string): ScheduleAlertLevel {
  switch (str) {
    case "WARNING":
      return "WARNING";
    case "BLOCKING":
      return "BLOCKING";
    default:
      throw new Error(`Unexpected alert level: ${str}`);
  }
}
